import { Component, inject, Signal } from '@angular/core';

import { NgScrollbar } from 'ngx-scrollbar';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { getRollupSelectedData } from '@app/store/rollups/rollups.selectors';
import { FormattedMoneyComponent } from '@app/framework/formated-money/formatted-money.component';
import { IRollupGCLineItem } from '@app/store/rollups/rollups.interface';
import { InteractionBarStateService } from '@app/services/interaction-bar-state.service';

@Component({
  selector: 'app-rollups-gcline-items-sidebar',
  imports: [FormattedMoneyComponent, NgScrollbar],
  templateUrl: './rollups-gcline-items-sidebar.component.html',
  styleUrl: './rollups-gcline-items-sidebar.component.scss',
})
export class RollupsGCLineItemsSidebarComponent {
  store = inject(Store);
  router = inject(Router);
  interactionBarStateService = inject(InteractionBarStateService);
  lineItem = toSignal(this.store.select(getRollupSelectedData)) as Signal<IRollupGCLineItem>;

  navigateToProject(project_id: number) {
    if (!project_id) {
      return;
    }
    this.router.navigate(['/webapp/projects', project_id]);
    this.interactionBarStateService.close();
  }
}
